module.exports = __webpack_public_path__ + "static/media/stripe.fb4644a0.png";